/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */

export type ContentVerificationStatusType =
  (typeof ContentVerificationStatusType)[keyof typeof ContentVerificationStatusType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentVerificationStatusType = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  RE_REVIEW_REQUESTED: 'RE_REVIEW_REQUESTED',
} as const;
